import { parsePhoneNumber } from 'libphonenumber-js';
export var validatePhoneIsValid = function validatePhoneIsValid(phone, config) {
  if (!phone) {
    return false;
  }

  try {
    var phoneNumber = parsePhoneNumber(phone);
    return phoneNumber && phoneNumber.isValid();
  } catch (e) {
    return false;
  }
};